// @ts-strict-ignore
import clsx from 'clsx'

import { Text } from '@/shared/ui'

import { Option as OptionType } from '../../types/types'

import cl from './Option.module.scss'

interface OptionProps {
	data: OptionType
	isSelected: boolean
	highlightText?: boolean
	onClick: (value: OptionType) => void
}

export const Option = (props: OptionProps) => {
	const { data, onClick, isSelected, highlightText } = props

	const classes = clsx(cl.option, {
		[cl.option__selected]: isSelected,
		[cl._text]: highlightText
	})

	return (
		<div onClick={() => onClick(data)} className={classes}>
			<Text className={cl.option__title}>{data?.label}</Text>
			{data?.helpText && <Text className={cl.option__helpText}>{data?.helpText}</Text>}
		</div>
	)
}
